import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DifferentialCard } from '@models/condition.models';
import { MarkdownPipe } from '@pipes/markdown.pipe';

@Component({
  selector: 'app-differential-card',
  templateUrl: './differential-card.component.html',
  styleUrls: ['./differential-card.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkdownPipe],
})
export class DifferentialCardComponent {
  @Input() card!: DifferentialCard;
  @Input() headingLevel: number = 3;
}
